export default "__VITE_ASSET__Ck8El2_j__"